import * as Actions from './PromoCodeActionTypes';

export const promoCodeReducer = (
  state = {
    promoCodeUsage: {
      fetching: false,
      error: { status: false, message: '' },
      data: []
    }
  },
  action
) => {
  switch (action.type) {
    case Actions.FETCH_PROMO_CODE_USAGE:
      return {
        ...state,
        promoCodeUsage: {
          ...state.promoCodeUsage,
          fetching: true,
          error: { status: false, message: '' },
          isRemoveAuth: false
        }
      };

    case Actions.FETCH_PROMO_CODE_USAGE_SUCCESS:
      return {
        ...state,
        promoCodeUsage: {
          ...state.promoCodeUsage,
          fetching: false,
          error: { status: false, message: '' },
          data: action.payload
        }
      };

    case Actions.FETCH_PROMO_CODE_USAGE_FAILS:
      return {
        ...state,
        promoCodeUsage: {
          ...state.promoCodeUsage,
          fetching: false,
          error: { status: true, message: action.payload }
        }
      };
    default:
      return state;
  }
};
